import { render, staticRenderFns } from "./ViewPurchasesInvoiceComponent.vue?vue&type=template&id=913c399c"
import script from "./ViewPurchasesInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesInvoiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports